module.exports = __webpack_public_path__ + "media/images/flags/16/Niger-6e9ecf08a181ee1744962995cc45740b.png";